import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, FileTextIcon, LockKeyholeIcon, SparklesIcon, ZapIcon } from 'lucide-react';
import { CheckoutButton } from './Button';
import { ProductName } from './ProductName';
const includes = ['6 volumes complets', '150 cours prêts à enseigner', 'Fondamentaux & Placement', 'Travail à la Barre', 'Centre, Adage & Équilibre', 'Pirouettes, Tours, Sauts & Allegro', 'Progressions, Corrections & Évaluation', '5 bonus professionnels', 'Contenu principal entièrement visuel', 'Format PDF', 'Accès immédiat'];
export function PricingSection() {
  return <section id="pricing" className="bg-brand-cream px-4 py-20 sm:py-28" data-id="element-194" data-mp="1x99kq9n339c2">
      <div className="mx-auto max-w-3xl" data-id="element-195" data-mp="2282vvveweo92">
        <div className="text-center" data-id="element-196" data-mp="225qizwnzz42v">
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-brand-deep" data-id="element-197" data-mp="2v8lhnnmgkbg">
            Votre offre complète aujourd’hui
          </p>
          <h2 className="mt-3 text-3xl font-semibold text-brand-ink sm:text-4xl" data-id="element-198" data-mp="7u1zriaqgfco">
            Tout ce dont votre prochaine classe a besoin, organisé dans un seul
            système.
          </h2>
        </div>
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mt-12 rounded-2xl border border-brand-gold/60 bg-white shadow-soft" data-id="element-199" data-mp="1hnva8o67o38s">
          <div className="absolute -top-3.5 left-1/2 inline-flex -translate-x-1/2 items-center gap-1.5 whitespace-nowrap rounded-full bg-brand-ink px-3.5 py-1 text-xs font-semibold uppercase tracking-[0.1em] text-white" data-id="element-200" data-mp="20gfx9oz8be4o">
            <SparklesIcon size={14} className="text-brand-gold" aria-hidden="true" data-id="element-201" data-mp="1rgauxt8w75xd" />{' '}
            Système 6-en-1
          </div>
          <div className="p-6 text-center sm:p-10" data-id="element-202" data-mp="k3r6ktcllofx">
            <h3 className="text-3xl font-semibold text-brand-ink" data-id="element-203" data-mp="g0ugyion4s2h">
              <ProductName data-id="element-204" data-mp="g2p6696y36cd" />
            </h3>
            <p className="mt-3 text-brand-muted" data-id="element-205" data-mp="hhi237p7gmge">
              Le système professionnel 6-en-1 pour préparer moins et enseigner
              avec plus de structure.
            </p>
            <p className="mt-7 text-left text-sm font-semibold text-brand-ink sm:mx-auto sm:max-w-xl" data-id="element-206" data-mp="7ju50b44n2v2">
              Vous recevez :
            </p>
            <ul className="mx-auto mt-3 grid max-w-xl gap-x-6 gap-y-2.5 border-y border-brand-line py-6 text-left sm:grid-cols-2" data-id="element-207" data-mp="ch3u1pnltcid">
              {includes.map(item => <li key={item} className="flex gap-2.5 text-sm leading-6 text-brand-ink" data-id="element-208" data-mp="3i8psj44echp">
                  <CheckIcon size={17} className="mt-0.5 shrink-0 text-brand-gold" aria-hidden="true" data-id="element-209" data-mp="3kwdrulkgnvkc" />
                  {item}
                </li>)}
            </ul>
            <div className="mt-8" data-id="element-210" data-mp="3fyc9k2uv009x">
              <span className="font-display text-5xl font-semibold text-brand-ink" data-id="element-211" data-mp="3g1hxherr4w42">
                27 EUR
              </span>
            </div>
            <CheckoutButton className="mt-7 w-full sm:w-auto" data-id="element-212" data-mp="2scjomqdywvlv">
              ACCÉDEZ AU SYSTÈME COMPLET MAINTENANT
            </CheckoutButton>
            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-medium text-brand-muted" data-id="element-213" data-mp="36d2vhu6p5vmg">
              <span className="flex items-center gap-1.5" data-id="element-214" data-mp="31f1erfwqu8e5">
                <LockKeyholeIcon size={14} className="text-brand-gold" aria-hidden="true" data-id="element-215" data-mp="3g8o3qa2czs4n" />
                Paiement sécurisé
              </span>
              <span className="flex items-center gap-1.5" data-id="element-216" data-mp="3p29ivuifrbel">
                <ZapIcon size={14} className="text-brand-gold" aria-hidden="true" data-id="element-217" data-mp="3p1rda79vvku0" />
                Accès immédiat
              </span>
              <span className="flex items-center gap-1.5" data-id="element-218" data-mp="3l31t9vucb51e">
                <FileTextIcon size={14} className="text-brand-gold" aria-hidden="true" data-id="element-219" data-mp="2vudnabyyvrq" />
                Format PDF
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}